import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { formatDateTime, getDetailPath } from '../../utils/meetingUtils';

import Spinner from '../../components/Spinner/Spinner'
import { toast } from 'react-hot-toast';
import { getMeetings } from '../../features/meeting/meetingSlice'



function MeetingList() {



    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth);
    const isAuthenticated = useSelector((state) => state.auth.user !== null);
    const { meetings, loadingStates, errors, message } = useSelector((state) => state.meeting);
    const isLoading = loadingStates?.getMeetings;
    const loadError = errors?.getMeetings;
    const currentUser = useSelector((state) => state.auth.user); 



    useEffect(() => {

        if (!isAuthenticated) {
            navigate('/login')
        }

        if (loadError) {
            toast.error(loadError || message);
        }


        dispatch(getMeetings())

    }, [isAuthenticated, navigate, loadError, message, dispatch])


    if (isLoading) {
        return <Spinner />
    }

    const formatDate = (date) => formatDateTime(date);
    const visibleMeetings = (meetings || []).filter((m) => m?.state !== false && m?.state !== 'false');







    return (
        <>
            <div className="row">

                {visibleMeetings.length > 0 ? (
                    <>
                        {visibleMeetings.map((meeting, index) => (
                            <div className="col-xl-3 col-xxl-4 col-lg-6 col-md-6 col-sm-6" key={index}>
                                <Link to={getDetailPath(meeting)}>
                                    <div className="card project-boxed">
                                        <div className="img-bx">
                                            <img src={meeting.coverPhoto} alt="" className=" me-3 card-list-img w-100 cover_meeting_list" width="130" />
                                        </div>
                                        <div className="card-header align-items-start">
                                            <div>
                                                <h6 className="fs-18 font-w500 mb-3 text-black user-name">{meeting.title}</h6>
                                                <div className="text-dark fs-14 text-nowrap"><i className="fa fa-calendar me-3" aria-hidden="true"></i>{formatDate(meeting.startDate)}</div>
                                                <div className="text-dark fs-14 text-nowrap"><i className="fa fa-map me-3" aria-hidden="true"></i>Online</div>
                                                <div className="text-dark fs-14 text-nowrap"><i className="fa fa-users me-3" aria-hidden="true"></i>{meeting.users?.length} Katılımcı</div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </>
                ) : (
                    <h3>Etkinlik Bulunamadı</h3>
                )}
            </div >
        </>

    )
}

export default MeetingList
